import { View, ViewOff } from '@carbon/icons-react';
import { useState } from 'react';
import type { RegisterOptions } from 'react-hook-form';
import { Input } from './hoc-components';

interface PasswordInputProps {
  name: string;
  label?: string;
  placeholder?: string;
  rules?: RegisterOptions;
  autocomplete?: string;
  className?: string;
}

export function PasswordInput({
  name,
  label,
  placeholder,
  rules,
  autocomplete,
  className,
}: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className={`password-input-wrapper ${className ?? ''}`}>
      <Input
        name={name}
        rules={rules}
        inputType={showPassword ? 'text' : 'password'}
        label={label}
        placeholder={placeholder}
        autocomplete={autocomplete}
      />
      <button
        type="button"
        className="password-input-wrapper__toggle"
        onClick={togglePasswordVisibility}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
      >
        {showPassword ? <View size={20} /> : <ViewOff size={20} />}
      </button>
    </div>
  );
}
